import { render, staticRenderFns } from "./PaymentMethodUpdate.vue?vue&type=template&id=2089bfb2&"
import script from "./PaymentMethodUpdate.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports